<template>
  <el-date-picker
    size="small"
    v-model="data"
    :type="pickerType"
    align="right"
    unlink-panels
    @change="handleChange"
    :value-format="valueFormat"
    :format="format"
    range-separator="~"
    :start-placeholder="startplh"
    :end-placeholder="endplh"
    :picker-options="pickOptionsType === 'sameMonth' ? pickerOptions : {}"
  >
  </el-date-picker>
</template>

<script>
import i18n from '@/locales/index'
export default {
  props: {
    value: {
      type: [String, Array]
    },
    startplh: {
      type: String,
      default: i18n.t('Common.startTime')
    },
    endplh: {
      type: String,
      default: i18n.t('Common.endTime')
    },
    pickerType: {
      type: String,
      default: 'daterange'
    },
    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    pickOptionsType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      data: this.value
    }
  },

  computed: {
    pickerOptions() {
      let _this = this
      return {
        onPick({ maxDate, minDate }) {
          console.log(1)
          if (!maxDate) {
            _this.minDate = minDate
          } else {
            _this.minDate = ''
          }
        },
        disabledDate(time) {
          if (_this.minDate) {
            let curYear = new Date(_this.minDate).getFullYear()
            let curMonth = new Date(_this.minDate).getMonth()
            // 本月的开始时间
            const monthStartDate = new Date(curYear, curMonth, 1).getTime()
            // 本月的结束时间
            const monthEndDate = new Date(curYear, curMonth + 1, 0).getTime()

            return time.getTime() < monthStartDate || time.getTime() > monthEndDate
          } else {
            return null
          }
        }
      }
    }
  },

  watch: {
    value(val) {
      this.data = val
    }
  },
  methods: {
    handleChange(val) {
      if (!val) {
        return this.$emit('input', ['', ''])
      }
      this.$emit('input', val)
    }
  }
}
</script>
